import React from "react";
import { Container } from "react-bootstrap";

export const PrivateBookingBanner = ({ banner, description }) => {
  return (
    <>
      <section className="section-private-booking-banner">
        <div
          className="cover animated fadeIn delayp1"
          style={{
            backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0)), url(${banner})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container">
            <h3 className="cover-title cover-title-sm cover-title-whatson animated fadeInUp delayp3">
              Private <br /> Booking
            </h3>
          </div>
        </div>
      </section>
      <section className="section-private-booking-description">
        <div className="container">
          <div
            className="animated fadeInUp delayp1"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </section>
    </>
  );
};
